import React from 'react'
import Navbar from '../inc/Navbar'
import {Link} from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import Garments from './Garments';
function Clothpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
<br/>
<ScrollToTop smooth top="100" color="Darkblue"/>
<div className='exportindian'>
    <div className="album py-1">
        <div className="container mt-3">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Garments</li>
                </ol>
            </nav>
        </div>
        </div>
    </div>
    <br/>
    <Garments/>
<br/>
    </div>
  )
}

export default Clothpage